import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { formatKonta } from "../../../../functions/utilities.js";
import { zamienPolskieZnaki } from "../../../../functions/dictionary.js";
import { fetchZaleglosciPowiadomienia } from "../../../../Redux/Actions.js";
import DialogYesNo from "../../../DialogYesNo.js";
import DialogOk from '../../../DialogOk.js';

const WspolnotaRozliczenieZaleglosciButtonWyslij = (props) => {

  const { tablica, setTablica, idw, user, ileSms, wybranyFiltr } = props;

  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);

  const [liczbaMaili, setLiczbaMaili] = useState(undefined);

  const dispatch = useDispatch();

  useEffect( () => {
    if (tablica && tablica?.length > 0)
      setLiczbaMaili( tablica?.filter( t => t?.czyWyslacEmail === true).length );
  }, [tablica])

  const sendLog = async (email_telefon, id_user, grupa_numer, kwota, kanal, uwagi) => {
    try {   
      // Wysyłamy dane na serwer
      await axios.post('/api/zaleglosci/send-log/', {
        email_telefon, user, id_user, grupa_numer, kwota, idw, kanal, uwagi
      }).then( response => {
        if (response.status === 200)          
          dispatch(fetchZaleglosciPowiadomienia(idw));
    })
      // Po udanym dodaniu danych możesz wykonać odpowiednie akcje, np. wyczyść formularz
    } catch (error) {
      console.error('Błąd podczas dodawania danych:', error);
    }
  }

  const sendMail = async (email, saldoPlus, id_user, grupa_numer, trescMail) => {
    let temat = '';
    const kanal = 'e-mail';
    if (wybranyFiltr == 1) {
      temat = 'Przypomnienie';

    } else if (wybranyFiltr == 2) {
      temat = 'Wezwanie';
    }
      
    try {   
      // Wysyłamy dane na serwer
      await axios.post('/api/zaleglosci/send-mail/', { email, temat, trescMail }).then(response => {
        if (response.status === 200) {
          const uwagi = '';
          sendLog(email, id_user, grupa_numer, saldoPlus, kanal, uwagi);
        }
      });
      // Po udanym dodaniu danych możesz wykonać odpowiednie akcje, np. wyczyść formularz
    } catch (error) {
      console.error('Błąd podczas wysyłania maila:', error);
    }
    
  }
  
  const handleSendEmail = () => {
    tablica.forEach( (element) => {
      if (element.czyWyslacEmail === true) {
        // sendMail(element.email, element.zalegloscTxT, element.konto);
        // const email = 'kacper.krojna@gmail.com';
        sendMail(
          // email, 
          element.email,
          element.saldoPlus, 
          element.udzial.id_user, 
          element.udzial.grupa_numer,
          element.trescMail
        );
      }        
    });
    const nowaTablica = tablica.map(element => ({
      ...element,
      czyWyslacEmail: false
    }));
    setTablica(nowaTablica);
  } 

  const sendSMS = async (telefon, saldoPlus, id_user, grupa_numer, trescSms) => {
    const kanal = 'sms';
    console.log(trescSms)
    try {
      await axios.post('/api/zaleglosci/send-sms/', {
        telefon, trescSms 
      }).then(response => {
        if (response?.data?.err?.data?.error > 0) {
          console.log(`Błąd: ${response?.data?.err?.data?.error}`)
          const uwagi = 'SMS nie został wysłany';
          sendLog(telefon, id_user, grupa_numer, saldoPlus, kanal, uwagi);
        } else {
          const uwagi = '';
          sendLog(telefon, id_user, grupa_numer, saldoPlus, kanal, uwagi);
        }
        /*if (response.status === 200) {
          sendLog(telefon, id_user, grupa_numer, saldoPlus, kanal);
        }*/
        console.log(response);
      });
      
    } catch (error) {
      console.error('Błąd podczas dodawania danych:', error);
    }
    
  };  

  const handleSendSMS = () => {
    tablica.forEach( element => {
      if (element.czyWyslacSms === true) {
        // const telefon = '533441513';
        sendSMS(
          element.telefon,
          // telefon,
          element.saldoPlus,
          element.udzial.id_user,
          element.udzial.grupa_numer,
          element.trescSms
        )
      }
    })
  }
 
  const handleEmailQuest = () => {
    const czyZaznaczone = tablica?.some( e => e.czyWyslacEmail === true);
    if (czyZaznaczone) 
      setOpen1(true);
    else
      setOpen3(true);
  }

  const handleSmsQuest = () => {
    if (ileSms > 0 ) 
      setOpen2(true);
    else
      setOpen3(true);
  }

  return (
    <div>
      <button
        disabled={ liczbaMaili === 0 ? true : false}
        onClick={handleEmailQuest}
        className="pointer"
      >
        Wyslij e-maile
      </button>
      <button
        disabled={ ileSms === 0 ? true : false }
        onClick={handleSmsQuest}
        className="pointer"
      >
        Wyslij SMSy
      </button>
      <DialogYesNo  
        open={open1}
        setOpen={setOpen1}
        message={`Czy na pewno chcesz wysłać maile z ${ wybranyFiltr == 1 ? 'przypomnieniem' : 'wezwaniem' }? (Liczba maili: ${liczbaMaili})`}
        f={handleSendEmail}
        id={null}
      />
      <DialogYesNo  
        open={open2}
        setOpen={setOpen2}
        message={`Czy na pewno chcesz wysłać SMSy z ${ wybranyFiltr == 1 ? 'przypomnieniem' : 'wezwaniem' }? (Liczba SMSów: ${ileSms})`}
        f={handleSendSMS}
        id={null}
      />
      <DialogOk
        open={open3}
        setOpen={setOpen3}
        message={`Zaznacz co najmniej jedną pozycję.`}
      />
    </div>      
  )
}

export default WspolnotaRozliczenieZaleglosciButtonWyslij;